import { Regione } from './enums';
import { Privilegio } from './auth';
import {
  CanaleAcquisizione,
  StatoCliente,
  TipoDocumentoCliente,
  TipologiaCliente,
} from './clienti';
import { TipoPartner } from './partner';
import { StatoFase, StatoProgetto, StatoScadenza } from './progetti';
import { PrioritaTask, StatoTask } from './task';
import { EventoFile } from './file';
import { ORARI_RIEPILOGO, OggettoPromemoria, TipoNotifica } from './notifiche';
import { TipoTokenUtente } from './utenti';
import { DatasetExport, FormatoExport, StatoEsportazione } from './export';
import { AzioneAudit } from './audit';

/**
 * Registro AGGREGATO di tutte le liste controllate, raccolte dai vari slice.
 * Usato dal seed, dai CHECK generati e dal test di coerenza `shared ↔ DB`
 * per non divergere in silenzio. Le chiavi corrispondono ai nomi
 * delle colonne/lookup a DB.
 */
export const listeControllate = {
  stato_cliente: StatoCliente.options,
  tipologia_cliente: TipologiaCliente.options,
  canale_acquisizione: CanaleAcquisizione.options,
  tipo_partner: TipoPartner.options,
  stato_progetto: StatoProgetto.options,
  stato_fase: StatoFase.options,
  stato_scadenza: StatoScadenza.options,
  stato_task: StatoTask.options,
  priorita_task: PrioritaTask.options,
  evento_file: EventoFile.options,
  privilegio: Privilegio.options,
  tipo_documento_cliente: TipoDocumentoCliente.options,
  regione: Regione.options,
  tipo_notifica: TipoNotifica.options,
  oggetto_promemoria: OggettoPromemoria.options,
  orario_riepilogo: ORARI_RIEPILOGO,
  tipo_token_utente: TipoTokenUtente.options,
  dataset_export: DatasetExport.options,
  formato_export: FormatoExport.options,
  stato_esportazione: StatoEsportazione.options,
  azione_audit: AzioneAudit.options,
} as const satisfies Record<string, readonly string[]>;

export type ListaControllata = keyof typeof listeControllate;
